const posixify = (path) => path.trim().replaceAll(/[/\\]+/g, "/");
const $slashWrapEnd = (path) => !path.endsWith("/") ? `${path}/` : path;
const slashWrapEnd = (path) => $slashWrapEnd(posixify(path));
const $slashWrapStart = (path) => !path.startsWith("/") ? `/${path}` : path;
const slashWrapStart = (path) => $slashWrapStart(posixify(path));
const slashWrap = (path) => $slashWrapStart($slashWrapEnd(posixify(path)));
const $slashTrimStart = (path) => {
  let res = path;
  while (res.startsWith("/")) {
    res = res.slice(1);
  }
  return res;
};
const slashTrimStart = (path) => $slashTrimStart(posixify(path));
function $slashTrimEnd(path) {
  let res = path;
  while (res.endsWith("/")) {
    res = res.slice(0, -1);
  }
  return res;
}
const slashTrimEnd = (path) => $slashTrimEnd(posixify(path));
const slashTrim = (path) => $slashTrimEnd($slashTrimStart(posixify(path)));
const guard = new URL("http:/*     */
const parseUrl = (url, base = guard) => new URL(url, base);
const isURL = (value) => {
  if (value instanceof URL) {
    return true;
  }
  try {
    if (typeof value === "object" && value) {
      return !!new URL(value.toString());
    }
  } catch {
  }
  return false;
};
const webJoin = (...paths) => (
  /*                                   */
  paths.slice(1).reduce(
    (base, path) => new URL(
      /*                              */
      slashTrimStart(isURL(path) ? path.pathname : path),
      /*                                        */
      new URL(slashWrapEnd(base.pathname), base)
    ),
    /*                        */
    new URL(paths[0], guard)
  )
);
const stripOrigin = (url) => {
  const parsed = isURL(url) ? url : new URL(url, guard);
  return parsed.href.slice(parsed.origin.length);
};

export { isURL, parseUrl, posixify, slashTrim, slashTrimEnd, slashTrimStart, slashWrap, slashWrapEnd, slashWrapStart, stripOrigin, webJoin };
/*                              */
